import {
  FormsModule,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

import { routing } from "./../app-routing.module";
import { InputMaskModule } from "ng2-inputmask";
import { element } from "protractor";

import { Pessoa } from "./../_shared/pessoa/pessoa";
import { PessoaService } from "./../_shared/pessoa/pessoa.service";
import { EnderecoService } from "./../_shared/endereco/endereco.service";
import { Pais } from "./../_shared/endereco/pais";
import { SessionService } from "./../_shared/session/session.service";
import { ProcessoService } from "./../_shared/processo/processo.service";
import { BarraProgressoService } from "./../_shared/barra-progresso/barra-progresso.service";
import { CursosService } from "./../_shared/curso/cursos.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  public estrangeiro: boolean;
  public validaSenha = false;
  public cpf: string;
  public pes_cpf_placeholder = "Insira seu CPF";
  public pes_cpf_classe: string;
  public pes_pass_num_placeholder = "Passaporte";
  public pes_pass_num_classe: string;
  public pes_senha_placeholder = "Insira sua senha da intranet";
  public pes_senha_classe: string;
  public form: FormsModule = new FormsModule();
  public senha: string;
  public pessoa: Pessoa = new Pessoa();
  public error = "";
  public pes_cpf_mask = [
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    ".",
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    ".",
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    "-",
    /[0-9]/,
    /[0-9]/,
  ];
  public paises: Array<Pais>;
  public pais_selecinado: Pais = {
    pais_cod: 1,
    pais_nom: "Selecione um País",
    id: 1,
    text: "Selecione um País",
  };
  public pais_classe: string;

  protected cursosSeletivo: any;

  constructor(
    private router: Router,
    private pessoaService: PessoaService,
    private route: ActivatedRoute,
    private SessionService: SessionService,
    private EnderecoService: EnderecoService,
    private BarraProgressoService: BarraProgressoService,
    private ProcessoService: ProcessoService,
    private cursosService: CursosService
  ) {
    // setando os parametros vindos pela url
    this.SessionService.setValor(
      "processo",
      this.route.snapshot.paramMap.get("processo")
    );
    this.SessionService.setValor(
      "curso",
      this.route.snapshot.paramMap.get("curso")
    );
    this.SessionService.setValor(
      "campus",
      this.route.snapshot.paramMap.get("campus")
    );
    this.SessionService.setValor(
      "turno",
      this.route.snapshot.paramMap.get("turno")
    );

    this.cursosService.carregaCursos().subscribe(
      (data) => {
        if (data[0]["TipoProcesso"].length == 0) {
          // if (this.SessionService.getValor('redirect') == 'true') {
          this.router.navigate(["/processo-fora-prazo"]);
          // }
        }
      },
      (error) => error
    );
  }

  ngOnInit() {

    this.EnderecoService.getPaises().subscribe((dados) =>
      this.trataPaises(dados)
    );

    let PrcTipPrc = this.EnderecoService.getPrcTipPrc();
    let PrcLetAnoUrl = this.EnderecoService.getPrcLetAnoUrl();
    let PrcLetSemUrl = this.EnderecoService.getPrcLetSemUrl();
    let PrcTipCod = this.EnderecoService.getPrcTipCodUrl();
    let PrcOcoSeq = this.EnderecoService.getPrcOcoSeqUrl();
    this.SessionService.setValor("PrcTipPrc", PrcTipPrc); //Chamado 560376 - Rafael dos Santos - 16/08/2024
    this.SessionService.setValor("PrcLetAnoUrl", PrcLetAnoUrl);
    this.SessionService.setValor("PrcLetSemUrl", PrcLetSemUrl);
    this.SessionService.setValor("PrcTipCodUrl", PrcTipCod);
    this.SessionService.setValor("PrcOcoSeqUrl", PrcOcoSeq);

    if (
      this.SessionService.getValor("token") ||
      this.pessoaService.getPessoa()
    ) {
      this.router.navigate(["/dados-pessoais"]);
      //this.router.navigate(['/pre-cadastro']);
    }

    if (this.ProcessoService.getNomeProcesso()) {
      this.BarraProgressoService.atualizaNomeProcesso(
        this.ProcessoService.getNomeProcesso()
      );
    }

    this.cursosService.carregaCursos().subscribe(
      (dataCurso) => {

        let processo = this.SessionService.getValor("processo");
        let isAchouProcesso = false;

        if (processo !== undefined && processo !== null && processo !== "") {
          dataCurso.forEach(curso => {
            const tipoProcessos = curso.TipoProcesso; // Acessando o array 'TipoProcesso'

            if (Array.isArray(tipoProcessos)) {
              tipoProcessos.forEach(tipoProcesso => {
                const ocorrencias = tipoProcesso.Ocorrencia; // Acessando o array 'Ocorrencia'

                if (Array.isArray(ocorrencias)) {
                  ocorrencias.forEach(ocorrencia => {
                    if (
                      PrcTipCod == tipoProcesso.PrcTipCod &&
                      PrcOcoSeq == ocorrencia.PrcOcoSeq &&
                      PrcLetAnoUrl == tipoProcesso.PrcLetAno &&
                      PrcLetSemUrl == tipoProcesso.PrcLetSem
                    ) {
                      isAchouProcesso = true;
                    }
                  });
                }
              });
            }
          });
        }

        if (dataCurso[0]["TipoProcesso"].length == 0 || (!isAchouProcesso && PrcTipPrc != "G" && PrcTipPrc != "" && PrcTipPrc !== null && PrcTipPrc !== undefined)) {
          this.router.navigate(["/processo-fora-prazo"]);
        } else {

          if (PrcTipPrc == "G" || PrcTipPrc == null || typeof PrcTipPrc == "undefined"){
          this.cursosSeletivo = JSON.stringify(dataCurso);
          this.SessionService.setValor("cursosSeletivo", this.cursosSeletivo);
          }else{
            let processo = sessionStorage.getItem("processo");

            if (processo === null || processo === undefined || processo === "" || processo === "null"){
              processo = "login";
            }

            this.cursosSeletivo = JSON.stringify(dataCurso);
            this.SessionService.setValor("cursosSeletivo", this.cursosSeletivo);
            this.router.navigate([`/${processo}`]);
          }
        }
      },
      (error) => error
    );
  }

  trataPaises(dados) {
    // Remove Brasil do array e add um selected
    dados.splice(1, 1);
    dados.unshift({ pais_cod: 1, pais_nom: "Selecione um País" });
    this.paises = dados;
  }

  mascaraPassaporte(event: any) {
    const pattern = /[a-zA-Z0-9 ]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (event.keyCode == "9" || event.keyCode == "8") {
      return true;
    }

    if (!pattern.test(inputChar)) {
      return false;
    }
  }

  setEstrangeiro(estrangeiro: boolean) {
    this.estrangeiro = estrangeiro;
  }

  verificaCampo() {
    if (this.estrangeiro) {
      this.verificaPassporte(this.pessoa.pes_pass_num);
    } else {
      this.verificaCpf(this.pessoa.pes_cpf);
    }
  }

  enterVerificaCampo(event) {
    if (event.keyCode === 13) {
      this.verificaCampo();
    }

    if (this.estrangeiro) {
      return this.mascaraPassaporte(event);
    }
  }

  verificaCpf(cpf: string) {
    this.pessoaService.validaCpf(cpf).subscribe(
      (data) => this.trataPasso(data),
      (error) => {
        if (!cpf) {
          this.pessoa.pes_cpf = "";
          this.pes_cpf_placeholder = "CPF é obrigatório";
          this.pes_cpf_classe = "classWarning";
        } else {
          this.pessoa.pes_cpf = "";
          this.pes_cpf_placeholder = "CPF inválido";
          this.pes_cpf_classe = "classErro";
        }
      }
    );
  }

  trataPasso(data) {
    this.pessoa.pais_cod_pass = this.pais_selecinado.pais_cod;
    if (data.pes_cod === "false") {
      this.pessoaService.setPessoa(this.pessoa);
      //this.router.navigate(['/dados-pessoais']);
      if (this.estrangeiro) {
        this.router.navigate(["/dados-pessoais"]);
      } else {
        this.router.navigate(["/pre-cadastro"]);
      }
    } else {
      this.pessoa.pes_cod = parseInt(data.pes_cod, 10);
      this.validaSenha = true;
    }
  }

  verificaPassporte(passaporte: string) {
    if (this.validaPais(this.pais_selecinado)) {
      this.pessoaService.validaPassaporte(passaporte).subscribe(
        (data) => this.trataPasso(data),
        (error) => {
          if (!passaporte) {
            this.pessoa.pes_pass_num = "";
            this.pes_pass_num_placeholder = "Passaporte é obrigatório";
            this.pes_pass_num_classe = "classWarning";
          } else {
            this.pessoa.pes_pass_num = "";
            this.pes_pass_num_placeholder = "Passaporte inválido";
            this.pes_pass_num_classe = "classErro";
          }
        }
      );
    }
  }

  validaPais(pais: Pais) {
    if (this.pais_selecinado.pais_cod === 1) {
      this.pais_classe = "classWarning";
      this.pes_pass_num_placeholder = "Passaporte é obrigatório";
      this.pes_pass_num_classe = "classWarning";
      return false;
    } else {
      this.pais_classe = "";
      return true;
    }
  }

  verificaSenha(senha: string) {
    this.pessoaService.login(String(this.pessoa.pes_cod), senha).subscribe(
      (data) => this.afterLogin(data),
      (error) => {
        if (!senha) {
          this.pessoa.pes_senha = "";
          this.pes_senha_placeholder = "Senha é obrigatório";
          this.pes_senha_classe = "classWarning";
        } else {
          this.pessoa.pes_senha = "";
          this.pes_senha_placeholder = "Senha inválida";
          this.pes_senha_classe = "classErro";
        }
      }
    );
  }

  enterVerificaSenha(event, senha) {
    if (event.keyCode === 13) {
      this.verificaSenha(senha);
    }
  }

  afterLogin(data) {
    this.pessoa.pes_senha = "";
    this.pes_senha_classe = "";
    this.pes_senha_placeholder = "Carregando";
    this.pessoaService.setPessoa(this.pessoa);
    this.SessionService.setValor("token", data.token);

    this.pessoaService.carregarPessoa(this.pessoa.pes_cod).subscribe(
      (res) => {
        this.pessoaService.setPessoa(Pessoa.fromJson(res));
        this.router.navigate(["/dados-pessoais"]);
        //this.router.navigate(['/pre-cadastro']);
      },
      (error) => error
    );
  }

  esqueciSenha() {
    window.open(
      "https://intranet.univali.br/esqueci.php",
      "Busca_Senha",
      "width=900, height=600"
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts